"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldDateStable = exports.sameOutputDate = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const __1 = require("..");
const classFunctions_1 = require("../../../../utils/classFunctions");
const dateTime_1 = require("../../../../utils/dateTime");
const dateTimeFormat_1 = require("../../../../utils/dateTimeFormat");
const locale_1 = require("../../../../utils/locale");
const mobilePlatform_1 = require("../../../../utils/mobilePlatform");
const DayPicker_1 = require("../../../Date/DayPicker");
const DayPickerFooter_1 = require("../../../Date/DayPickerFooter");
const DayPickerWrapper_1 = require("../../../Date/DayPickerWrapper");
const YearMonthForm_1 = require("../../../Date/YearMonthForm");
const useOutDateClick_1 = require("./useOutDateClick");
require("react-day-picker/lib/style.css");
require("./index.scss");
const className = 'form-field-date';
/** Empty date is really empty. Skip null !== undefined !== ''. It does not matter */
const castEmpty = (x) => [null, undefined, ''].includes(x) ? '' : x;
const sameOutputDate = (x, y) => castEmpty(x) === castEmpty(y);
exports.sameOutputDate = sameOutputDate;
const FormFieldDateStable = (props) => {
    var _a, _b;
    const { value, setValue, nativeValue, setNativeValue, onChange, name, label, error, required, disabled, hidden, additionClassNames, modificators, showUpper, dateRestrictions, inputModificators, modifiers, modifiersStyles, } = props;
    const intl = (0, react_intl_1.useIntl)();
    const [isOpenPicker, setIsOpenPicker] = (0, react_1.useState)(false);
    const [viewDate, setViewDate] = (0, react_1.useState)((_b = (_a = (0, dateTime_1.parseOutputDateTime)(value)) === null || _a === void 0 ? void 0 : _a.toDate()) !== null && _b !== void 0 ? _b : (0, dateTime_1.todayZeroTime)());
    (0, react_1.useEffect)(() => {
        var _a, _b;
        setViewDate((_b = (_a = (0, dateTime_1.parseOutputDateTime)(value)) === null || _a === void 0 ? void 0 : _a.toDate()) !== null && _b !== void 0 ? _b : (0, dateTime_1.todayZeroTime)());
    }, [value]);
    const selectedDate = (0, react_1.useMemo)(() => { var _a; return (_a = (0, dateTime_1.parseOutputDateTime)(value)) === null || _a === void 0 ? void 0 : _a.toDate(); }, [value]);
    const { rootRef } = (0, useOutDateClick_1.useOutDateClick)(() => {
        if (!isOpenPicker)
            return;
        setIsOpenPicker(false);
        setNativeValue === null || setNativeValue === void 0 ? void 0 : setNativeValue((0, dateTime_1.standardizeInputDate)(nativeValue));
    });
    const isMobile = (0, mobilePlatform_1.checkMobilePlatform)();
    const disabledDays = (0, dateTime_1.getDisabledDays)(dateRestrictions);
    const dayPickerProps = {
        captionElement: ({ localeUtils }) => {
            const yearMonthFormProps = {
                date: viewDate,
                localeUtils,
                onChange: (newDate) => {
                    if (newDate !== viewDate) {
                        setViewDate === null || setViewDate === void 0 ? void 0 : setViewDate(newDate);
                    }
                },
                restrictions: dateRestrictions,
            };
            return (react_1.default.createElement(YearMonthForm_1.YearMonthForm, { ...yearMonthFormProps }));
        },
        numberOfMonths: 1,
        selectedDays: selectedDate,
        disabledDays,
        onDayClick: (newDate, dayModifiers) => {
            if (dayModifiers.disabled)
                return;
            const newValue = (0, moment_1.default)(newDate).format(dateTimeFormat_1.DATE_OUTPUT_FORMAT);
            setValue === null || setValue === void 0 ? void 0 : setValue(newValue);
            setIsOpenPicker(false);
        },
        month: viewDate,
        firstDayOfWeek: 1,
        onMonthChange: (newDate) => {
            setViewDate === null || setViewDate === void 0 ? void 0 : setViewDate(newDate);
        },
        locale: (0, locale_1.mapLocaleToLocaleCode)(intl.locale),
        modifiers,
        modifiersStyles,
    };
    const dayPickerFooterProps = {
        resetHidden: !nativeValue,
        onClose: () => {
            setIsOpenPicker(false);
        },
        onResetClick: () => {
            setValue === null || setValue === void 0 ? void 0 : setValue(undefined);
        },
    };
    const pickerElement = isOpenPicker && (react_1.default.createElement(DayPickerWrapper_1.DayPickerWrapper, null,
        react_1.default.createElement("div", { className: `${className}__picker-body` },
            react_1.default.createElement(DayPicker_1.DayPicker, { ...dayPickerProps })),
        react_1.default.createElement("div", { className: `${className}__picker-footer` },
            react_1.default.createElement(DayPickerFooter_1.DayPickerFooter, { ...dayPickerFooterProps }))));
    const dateFieldProps = {
        nativeValue,
        onChange: (event) => {
            setIsOpenPicker(true);
            onChange === null || onChange === void 0 ? void 0 : onChange(event);
        },
        error,
        required,
        disabled,
        modificators: inputModificators,
        label,
        onFocus: () => {
            setIsOpenPicker(true);
        },
        placeholder: (0, moment_1.default)().format(dateTimeFormat_1.DATE_FORMAT),
        inputMode: isMobile ? 'none' : 'text',
        addonIcon: 'calendar',
        name,
    };
    const classNames = (0, classFunctions_1.getClassNames)(className, modificators, additionClassNames);
    if (hidden)
        return null;
    return (react_1.default.createElement("div", { className: classNames, ref: rootRef },
        showUpper && pickerElement,
        react_1.default.createElement("div", { className: 'form-fields-together' },
            react_1.default.createElement(__1.FormFieldStable, { ...dateFieldProps })),
        !showUpper && pickerElement));
};
exports.FormFieldDateStable = FormFieldDateStable;
//# sourceMappingURL=stable.js.map